import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import logoImage from './../assets/images/logo.png';
import { useFormik } from 'formik';
import * as yup from 'yup';
import PriceSummery from '../component/PriceSummery';
import { Link } from 'react-router-dom';
import 'react-credit-cards/es/styles-compiled.css';
import Cards from 'react-credit-cards';
import InputMask from 'react-input-mask';
import ThreeDSecureModal from '../component/ThreeDSecureModal';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../component/Laoding';
import { brokerFailedEmail, customerFailedEmail } from '../store/emails/emailActions';
import { encryptTotalAmount, encryptTransactionAmount } from '../utils/storage';






const validationSchema = yup.object({
    cardnumber: yup.string()
        .matches(/^\d{16}$/, "Card number is not valid")
        .required("Card number is required"),
    name: yup.string()
        .min(2, "Name must be at least 2 characters")
        .required("Name is required"),
    expiry: yup.string()
        .matches(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/, "Expiry date is not valid (MM/YY)")
        .required("Expiry date is required"),
    cvc: yup.string()
        .matches(/^\d{3}$/, "CVC is not valid")
        .required("CVC is required"),
    email: yup.string().email('Must be a valid email').max(255).required('Email is required'),
});



function CardDetails() {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.user.user);
    const [focus, setFocus] = useState('');
    const [isModalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const referenceCode = localStorage.getItem('loginData');
    const refData = JSON.parse(referenceCode);
    // const totalPrice = useSelector((state) => state.paymentSummery.totalPrice);
    const fullPrice = useSelector((state) => state.paymentSummery.fullPrice);
    const monthlyPrice = useSelector((state) => state.paymentSummery.depositPrice);
    const monthlyFullPrice = useSelector((state) => state.paymentSummery.monthlyPrice);
    const plan = useSelector((state) => state.paymentSummery.plan);
    const [loading, setLoading] = useState(false);

    // Function to show the modal
    // const showModal = () => {
    //     setModalVisible(true);
    // };

    // Function to hide the modal
    const hideModal = () => {
        setModalVisible(false);
    };

    // const iframeRef = useRef(null);

    // useEffect(() => {
    //     // Set global variables for the external script
    //     window.basketFormID = "basketform";  // Making basketFormID global
    //     window.successPage = "transaction success page";  // Making successPage global

    //     // Load the external hosted fields script
    //     const script = document.createElement("script");
    //     script.src = "https://payments.monek.com/hostedfields/js/hostedFields.js";
    //     script.async = true;
    //     document.body.appendChild(script);

    //     return () => {
    //       document.body.removeChild(script);
    //     };
    //   }, []);

    //   const handlePayment = () => {
    //     // Call hfSend using the globally defined basketFormID and successPage
    //     if (window.hfSend) {
    //       window.hfSend(window.basketFormID, window.successPage);
    //     } else {
    //       console.error("hfSend function not found. Make sure the script is loaded.");
    //     }
    //   };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            cardnumber: '',
            name: '',
            expiry: '',
            cardexpiremonth: '',
            cardexpireyear: '',
            cvc: '',
            email: '',
            accountHolderDetails: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setLoading(true)
            const [month, year] = values.expiry.split("/");
            const updatedValues = {
                ...values,
                cardexpiremonth: month,
                cardexpireyear: year,
            };

            // Prepare FormData for POST request
            const formData = new FormData();
            formData.append("hostedfields", 'true');
            formData.append("shreference", 'SH219326');
            // formData.append("shreference", 'SH '+refData.referenceCode);
            formData.append("checkcode", "731546");
            formData.append("transactionamount", "1");
            // formData.append("transactionamount", plan.type === 'yearly' ? fullPrice : monthlyPrice);
            formData.append("successUrl", "https://thamesbank.netlify.app/#/thankyou/" + refData.referenceCode);
            formData.append("errorUrl", "https://thamesbank.netlify.app/#/error");
            formData.append("ResponseAction", "REDIRECT");
            Object.keys(updatedValues).forEach((key) => {
                formData.append(key, updatedValues[key]);
            });
            // setLoading(true)
            // console.log(JSON.stringify('Month '+values.cardexpiremonth));
            localStorage.setItem('useremail', values.email)
            encryptTransactionAmount.setItem('TAb68f38dbe5a58552', plan.type === 'yearly' ? fullPrice : monthlyPrice);
            encryptTotalAmount.setItem('MAb68f38dbe5a2', plan.type === 'yearly' ? fullPrice : monthlyFullPrice);
            // console.log(formData)
            // navigate('/bankdetails', { replace: true });
            console.log(JSON.stringify('Year ' + values.cardexpireyear));
            // console.log(formData)
            fetch("https://www.secure-server-hosting.com/secutran/transactionsi1.php", {
                method: "POST",
                body: formData,
            }).then(
                response => response.text()
            ).then((result) => {
                setModalContent(result); // Set modal content with the result
                setModalVisible(true);   // Show the modal
                const parser = new DOMParser();
                const doc = parser.parseFromString(result, "text/html");
                const title = doc.querySelector("title")?.innerText
                // console.log("Form submitted successfully:", result);
                if (title) {
                    const emailData = {
                        toEmail: values.email,
                        fullName: userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"] + ' ' + userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"],
                        productName: "Insurer Premium",
                        sessionReference: refData.referenceCode,
                    };
                    const brokerEmail = {
                        toEmail: "gavin@paragon-uk.net",
                        sessionReference: refData.referenceCode,
                        brokerReference: refData.referenceCode,
                        clientReference: refData.referenceCode,
                        fullName: userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"] + ' ' + userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"],
                        premium: "Premium",
                        contactNumber: `"${userData?.HomeDetails?.Telephone1}"`,
                        alternateContact: ""
                    }
                    dispatch(customerFailedEmail(emailData));
                    dispatch(brokerFailedEmail(brokerEmail));
                }
                setLoading(false)
            }).catch(
                error => {
                    console.error("Error submitting form:", error);
                    setLoading(false)
                }
            );
        }
    });
    return (<>
        {loading ? <Loading /> : null}
        <ThreeDSecureModal show={isModalVisible} onHide={hideModal} modalContent={modalContent} />
        <div className='payment-page-wraper'>
            <Container fluid>
                <Row className='align-items-center'>
                    <Col md={7}>
                        <div className='payment-page-left-area'>
                            <Row className='align-items-center'>
                                <Col md={5}>
                                    <div className='logo'>
                                        <img src={logoImage} alt='Thames Bank' />
                                    </div>
                                </Col>
                                <Col md={7}>
                                    {/* <h1 className='text-end'>Payment (2 of 2)</h1> */}
                                </Col>
                            </Row>
                            {/* <form id="basketform">
        <input type="hidden" name="shreference" value="shXXXXXX" />
        <input type="hidden" name="checkcode" value="123456" />
        <input type="hidden" name="transactionamount" value="5.00" />
      </form>
      <iframe
        ref={iframeRef}
        src="https://payments.monek.com/hostedfields/hostedFields.php"
        title="Hosted Field"
        style={{ border: 0, display: 'block' }}
        width="80%"
        height="475"
      ></iframe>
      <button onClick={handlePayment} className="btn btn-info">
        Complete Order
      </button> */}
                            <h1 className='mt-4'>Payment</h1>
                            <p>Finally, we require a credit or debit card payment of £{plan.type === 'yearly' ? fullPrice : monthlyPrice}. Please enter your credit or debit card details below. Once again, please be reassured this is a secure SSL encrypted service, so your details are safe.</p>
                            <div className='form-main mt-3'>
                                <Row>
                                    <Col md={6}>
                                        <Form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
                                            {/* <input type="hidden" name="shreference" value="SH219326" />
                                            <input type="hidden" name="checkcode" value="731546" />
                                            <input type="hidden" name="transactionamount" value="0.1" /> */}
                                            {/* <input type="hidden" name="successUrl" value="http://localhost:3000/#/success" />
                                            <input type="hidden" name="errorUrl" value="http://localhost:3000/#/error" /> */}
                                            <Form.Group as={Col} md="12" controlId="email" className="position-relative mb-3">
                                                <Form.Label>Email *</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Please enter..."
                                                    name="email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!formik.errors.email}
                                                    isValid={formik.touched.email}
                                                />
                                                <Form.Control.Feedback type="invalid" tooltip>
                                                    {formik.errors.email}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} md="12" controlId="cardnumber" className="position-relative mb-3">
                                                <Form.Label>Card number *</Form.Label>
                                                <InputMask
                                                    mask="9999 9999 9999 9999"
                                                    maskChar=" "
                                                    name="cardnumber"
                                                    placeholder="Card Number"
                                                    value={formik.values.cardnumber}
                                                    onChange={(e) => formik.setFieldValue('cardnumber', e.target.value.replace(/\s/g, ''))}
                                                    onBlur={formik.handleBlur}
                                                    onFocus={() => setFocus('cardnumber')}
                                                    isInvalid={!!formik.errors.cardnumber}
                                                    className={`form-control ${formik.touched.cardnumber && formik.errors.cardnumber ? 'is-invalid' : formik.touched.cardnumber ? 'is-valid' : ''
                                                        }`}
                                                />
                                                {formik.touched.cardnumber && formik.errors.cardnumber && (
                                                    <div className="invalid-tooltip">{formik.errors.cardnumber}</div>
                                                )}
                                            </Form.Group>
                                            <Form.Group as={Col} md="12" controlId="name" className="position-relative mb-3">
                                                <Form.Label>Cardholder name *</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name on Card"
                                                    name="name"
                                                    value={formik.values.name}
                                                    onChange={formik.handleChange}
                                                    onFocus={() => setFocus('name')}
                                                    onBlur={formik.handleBlur}
                                                    className={`form-control ${formik.touched.name && formik.errors.name ? 'is-invalid' : formik.touched.name ? 'is-valid' : ''
                                                        }`}
                                                />
                                                <Form.Control.Feedback type="invalid" tooltip>
                                                    {formik.errors.name}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Col md={12}>
                                                <Row>
                                                    <Form.Group as={Col} md="6" controlId="expiry" className="position-relative mb-3">
                                                        <Form.Label>Card expiry date *</Form.Label>
                                                        <InputMask
                                                            mask="99/99"
                                                            maskChar=" "
                                                            name="expiry"
                                                            placeholder="Expiry (MM/YY)"
                                                            value={formik.values.expiry}
                                                            onChange={(e) => formik.setFieldValue('expiry', e.target.value)}
                                                            onBlur={formik.handleBlur}
                                                            onFocus={() => setFocus('expiry')}
                                                            isInvalid={!!formik.errors.expiry}
                                                            className={`form-control ${formik.touched.expiry && formik.errors.expiry ? 'is-invalid' : formik.touched.expiry ? 'is-valid' : ''
                                                                }`}
                                                        />
                                                        {formik.touched.expiry && formik.errors.expiry && (
                                                            <div className="invalid-tooltip">{formik.errors.expiry}</div>
                                                        )}
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="6" controlId="cvc" className="position-relative mb-3">
                                                        <Form.Label>CVC *</Form.Label>
                                                        <InputMask
                                                            mask="999"
                                                            maskChar=" "
                                                            name="cvc"
                                                            placeholder="CVC"
                                                            value={formik.values.cvc}
                                                            onChange={(e) => formik.setFieldValue('cvc', e.target.value)}
                                                            onBlur={formik.handleBlur}
                                                            onFocus={() => setFocus('cvc')}
                                                            isInvalid={!!formik.errors.cvc}
                                                            className={`form-control ${formik.touched.cvc && formik.errors.cvc ? 'is-invalid' : formik.touched.cvc ? 'is-valid' : ''
                                                                }`}
                                                        />
                                                        {formik.touched.cvc && formik.errors.cvc && (
                                                            <div className="invalid-tooltip">{formik.errors.cvc}</div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Form.Group as={Col} md="12" controlId="accountHolderDetails" className="position-relative mb-3">
                                                <Form.Label>Account holder details</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={8}
                                                    placeholder="Please enter..."
                                                    name="accountHolderDetails"
                                                    value={formik.values.accountHolderDetails}
                                                    onChange={formik.handleChange}
                                                />
                                            </Form.Group>
                                            <div>
                                                <Link to={plan.type === 'yearly' ? "/product" : "/bankdetails"} className='btn btn-light me-3'>Previous</Link>
                                                <Button type="submit" style={{ minWidth: '161px' }}>Pay Now</Button>
                                            </div>
                                        </Form>
                                    </Col>
                                    <Col md={6}>
                                        <Cards
                                            number={formik.values.cardnumber}
                                            name={formik.values.name}
                                            expiry={formik.values.expiry.replace('/', '')}
                                            cvc={formik.values.cvc}
                                            focused={focus}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col md={5}>
                        <PriceSummery />
                    </Col>
                </Row>
            </Container>
        </div>
    </>);
}




export default CardDetails;